var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 10,
    fill: "#2C3D50",
    stroke: "#FF8000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0903 17.8682V11H14.9097V17.8682H16.0903ZM14.8208 19.6899C14.8208 19.8804 14.8779 20.0412 14.9922 20.1724C15.1107 20.3035 15.2842 20.3691 15.5127 20.3691C15.737 20.3691 15.9084 20.3035 16.0269 20.1724C16.1496 20.0412 16.2109 19.8804 16.2109 19.6899C16.2109 19.508 16.1496 19.3514 16.0269 19.2202C15.9084 19.0933 15.737 19.0298 15.5127 19.0298C15.2842 19.0298 15.1107 19.0933 14.9922 19.2202C14.8779 19.3514 14.8208 19.508 14.8208 19.6899Z",
    fill: "#FF8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.64532319e94a97241afa30f9dc46a4f7.svg";
export { ForwardRef as ReactComponent };